export default __webpack_public_path__ + "static/unicornmetalics-icon-d6ed44adc6ba9002227f3e203258bbb1.png";